import { branch, renderNothing } from "recompose";

const withHidden = () => branch((props) => !!props.hidden, renderNothing);

export default withHidden;
